import React from "react";
import InstantBookingDataService from "../../services/InstantBooking";
import {
  Button,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
} from "@chakra-ui/react";
export const DeleteInstantBooking = ({ isOpen, onClose, id, func }: any) => {
  const deleteAssessments = () => {
    InstantBookingDataService.deleteBooking(id)
      .then((response: any) => {
        func(true);
        onClose();
      })
      .catch((e: Error) => {
        console.log(e);
      });
  };
  return (
    <Modal isOpen={isOpen} onClose={onClose}>
      <ModalOverlay />
      <ModalContent>
        <ModalHeader>Delete Expert</ModalHeader>
        <ModalCloseButton />
        <ModalBody>Are you sure you want to delete booking?</ModalBody>

        <ModalFooter>
          <Button
            bgColor="#327171"
            color={"white"}
            mr={3}
            onClick={deleteAssessments}
          >
            Delete
          </Button>
          <Button bgColor="red" color={"white"} mr={3} onClick={onClose}>
            No
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
};
